import Vue from 'vue'
import Router from 'vue-router'

import App from '@/App.vue'

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  routes: [
    {
      path: '/',
      alias: '/temps',
      name: 'El temps',
      component: App,
    }, {
      path: '/analisi',
      name: 'Anàlisi',
      component: App,
    }, {
      path: '/mapes',
      name: 'Mapes',
      component: App,
    }, {
      path: '/dades',
      name: 'Dades',
      component: App,
    },
  ],
})
